import React, { useState, useEffect, useCallback, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteLeft, faStar, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import './TestimonialsSection.css';

const testimonials = [
  {
    id: 1,
    name: 'Edna',
    company: 'A HORA DOS MENINOS',
    initials: 'E',
    color: '#00C2FF',
    rating: 5,
    text: 'Sistema com muitas funcionalidades que facilitam a rotina da loja, com atualizações periódicas para melhoria e com suporte acessível e eficiente! Super indico!',
  },
  {
    id: 2,
    name: 'Gregory',
    company: 'LAFIFI',
    initials: 'G',
    color: '#FF6B35',
    rating: 5,
    text: 'O sistema é bem simples de operar e me surpreendeu nas informações, também com a conectividade com e-commerce, o atendimento é muito rápido e preciso.',
  },
  {
    id: 3,
    name: 'Ebtssam',
    company: 'PEQUENO ANGEL',
    initials: 'E',
    color: '#10B981',
    rating: 5,
    text: 'A plataforma é simples e didática, o suporte é super rápido e sempre ajudam a resolver problemas e dúvidas de forma clara e ágil, super recomendo',
  },
  {
    id: 4,
    name: 'Reginaldo',
    company: 'FANSER MODAS',
    initials: 'R',
    color: '#F59E0B',
    rating: 5,
    text: 'Trocamos de sistema recentemente e estamos nos adaptando, está sendo bom, pois o sistema possui ferramentas que nos ajudam a melhorar nossas vendas.',
  },
  {
    id: 5,
    name: 'Lauro',
    company: 'ZERO HUM',
    initials: 'L',
    color: '#8B5CF6',
    rating: 5,
    text: 'Tenho o sistema deles na minha loja, eles têm o melhor atendimento e fácil acesso para abertura de chamados.',
  },
  {
    id: 6,
    name: 'João',
    company: 'UBIALLI',
    initials: 'J',
    color: '#00C2FF',
    rating: 5,
    text: 'Ótimo sistema, cada dia melhorando e evoluindo, integração multicanais de e-commerce muito boa.',
  },
  {
    id: 7,
    name: 'Renato',
    company: 'VG VILLAGE',
    initials: 'R',
    color: '#FF6B35',
    rating: 5,
    text: 'A empresa de sistemas INFOMEZZ demonstra um compromisso sólido com a inovação tecnológica e oferece soluções eficazes para as necessidades em constante evolução do mercado.',
  },
  {
    id: 8,
    name: 'Danielle',
    company: 'NINA LINDA',
    initials: 'D',
    color: '#10B981',
    rating: 5,
    text: 'O programa é muito funcional, uma mão na roda para a nossa rotina. Sem falar no suporte, sempre disponível e eficiente.',
  },
  {
    id: 9,
    name: 'Thais',
    company: 'ENCANTO PB',
    initials: 'T',
    color: '#F59E0B',
    rating: 5,
    text: 'Sistema de ótima qualidade, atendimento impecável.',
  },
  {
    id: 10,
    name: 'Lavi',
    company: 'LAVI CLOSET',
    initials: 'L',
    color: '#8B5CF6',
    rating: 5,
    text: 'Ótima experiência. A assistência é muito boa e o sistema é muito completo.',
  },
];

const TestimonialsSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const timerRef = useRef(null);

  const goTo = useCallback(
    (index) => {
      if (isAnimating) return;
      setIsAnimating(true);
      setActiveIndex((index + testimonials.length) % testimonials.length);
      setTimeout(() => setIsAnimating(false), 500);
    },
    [isAnimating]
  );

  const next = useCallback(() => goTo(activeIndex + 1), [activeIndex, goTo]);
  const prev = useCallback(() => goTo(activeIndex - 1), [activeIndex, goTo]);

  useEffect(() => {
    if (isPaused) return;
    timerRef.current = setInterval(next, 6000);
    return () => clearInterval(timerRef.current);
  }, [next, isPaused]);

  const currentTestimonial = testimonials[activeIndex];

  return (
    <section
      className="testimonials"
      id="depoimentos"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="container">
        {/* Header */}
        <div className="testimonials__header">
          <span className="testimonials__label">DEPOIMENTOS</span>
          <h2 className="testimonials__title">
            O que nossos clientes{' '}
            <span className="testimonials__title-highlight">dizem sobre nós</span>
          </h2>
        </div>

        {/* Carousel */}
        <div className="testimonials__carousel">
          <div className={`testimonials__card ${isAnimating ? 'testimonials__card--animating' : ''}`}>
            {/* Quote icon */}
            <div className="testimonials__quote-icon">
              <FontAwesomeIcon icon={faQuoteLeft} />
            </div>

            {/* Stars */}
            <div className="testimonials__stars">
              {Array.from({ length: currentTestimonial.rating }).map((_, i) => (
                <FontAwesomeIcon key={i} icon={faStar} className="testimonials__star" />
              ))}
            </div>

            {/* Texto do depoimento */}
            <p className="testimonials__text">"{currentTestimonial.text}"</p>

            {/* Autor */}
            <div className="testimonials__author">
              <div
                className="testimonials__avatar"
                style={{ background: `linear-gradient(135deg, ${currentTestimonial.color}, ${currentTestimonial.color}99)` }}
              >
                {currentTestimonial.initials}
              </div>
              <div className="testimonials__author-info">
                <strong className="testimonials__author-name">{currentTestimonial.name}</strong>
                <span className="testimonials__author-role">
                  • {currentTestimonial.company}
                </span>
              </div>
            </div>
          </div>

        </div>

        {/* Controles */}
        <div className="testimonials__controls">
          <button className="testimonials__nav-btn" onClick={prev} aria-label="Anterior">
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>

          <div className="testimonials__dots">
            {testimonials.map((_, i) => (
              <button
                key={i}
                className={`testimonials__dot ${i === activeIndex ? 'testimonials__dot--active' : ''}`}
                onClick={() => goTo(i)}
                aria-label={`Ir para depoimento ${i + 1}`}
              />
            ))}
          </div>

          <button className="testimonials__nav-btn" onClick={next} aria-label="Próximo">
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
